import CONSTANTS from '@picsio/db/src/constants';

function getDispatchTypeByAsyncStatus(status) {
  if (status === CONSTANTS.ASYNC_JOB_STATUS_WAITING) return 'START';
  if (status === CONSTANTS.ASYNC_JOB_STATUS_FAILED) return 'FAILED';
  return 'COMPLETE';
}

export default getDispatchTypeByAsyncStatus;
